// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// import { types } from 'node-sass';
import { DirectPropertyOwner } from '@shared/utils/Enums/Constants';
export class RulesCache {
    constructor(datacache) {
        this.RulesByAccount = {};
        this.RulesByUser = {};
        this.RulesByUserGroup = {};
        this.FeatureFlags = {};
        this.GlobalRules = {};
        this.DataCache = datacache;
    }
    Clear() {
        this.RulesByAccount = {};
        this.RulesByUser = {};
        this.RulesByUserGroup = {};
        this.FeatureFlags = {};
        this.GlobalRules = {};
    }
    AddRule(ownerType, ownerID, ruleKey, ruleValue) {
        switch (ownerType) {
            case DirectPropertyOwner.Account:
                if (!this.RulesByAccount.hasOwnProperty(ownerID)) {
                    this.RulesByAccount[ownerID] = {};
                }
                this.RulesByAccount[ownerID][ruleKey] = ruleValue;
                break;
            case DirectPropertyOwner.User:
                if (!this.RulesByUser.hasOwnProperty(ownerID)) {
                    this.RulesByUser[ownerID] = {};
                }
                this.RulesByUser[ownerID][ruleKey] = ruleValue;
                break;
            case DirectPropertyOwner.Group:
                if (!this.RulesByUserGroup.hasOwnProperty(ownerID)) {
                    this.RulesByUserGroup[ownerID] = {};
                }
                this.RulesByUserGroup[ownerID][ruleKey] = ruleValue;
                break;
            default:
                this.GlobalRules[ruleKey] = ruleValue;
                break;
        }
    }
    AddFeatureFlag(ruleKey, ruleValue) {
        this.FeatureFlags[ruleKey] = ruleValue;
    }
    // Get rule value from cache
    GetRuleValue(ruleName, account) {
        let acc = account;
        if (isNullOrUndefined(acc)) {
            acc = this.DataCache.getPrimaryAccount();
        }
        if (!isNullOrUndefined(acc)) {
            if (this.RulesByAccount.hasOwnProperty(acc.BstrAccount) &&
                this.RulesByAccount[acc.BstrAccount].hasOwnProperty(ruleName)) {
                return this.RulesByAccount[acc.BstrAccount][ruleName];
            }
            if (this.RulesByUser.hasOwnProperty(acc.userID) && this.RulesByUser[acc.userID].hasOwnProperty(ruleName)) {
                return this.RulesByUser[acc.userID][ruleName];
            }
            let groupMessage = this.DataCache.GetUserGroupById(acc.User.GroupId);
            while (groupMessage != null) {
                const groupId = groupMessage.GroupId;
                if (this.RulesByUserGroup.hasOwnProperty(groupId) &&
                    this.RulesByUserGroup[groupId].hasOwnProperty(ruleName)) {
                    return this.RulesByUserGroup[groupId][ruleName];
                }
                groupMessage = this.DataCache.GetUserGroupById(groupMessage.SuperGroupId);
            }
        }
        return this.GlobalRules.hasOwnProperty(ruleName) ? this.GlobalRules[ruleName] : null;
    }
    IsAllowedForAccount(ruleName, account) {
        return this.GetRuleValue(ruleName, account) === '1';
    }
    IsExistForAccount(ruleName, account) {
        return this.GetRuleValue(ruleName, account) !== null;
    }
    IsAllowedFeatureFlag(ruleName) {
        if (this.FeatureFlags.hasOwnProperty(ruleName)) {
            return this.FeatureFlags[ruleName] === 'true';
        }
        return false;
    }
    IsAllowedForUser(ruleName, user) {
        if (user == null) {
            return false;
        }
        for (let i = 0; i < user.Accounts.length; i++) {
            if (this.IsAllowedForAccount(ruleName, user.Accounts[i])) {
                return true;
            }
        }
        return false;
    }
    IsExistForUser(ruleName, user) {
        if (user == null) {
            return false;
        }
        for (let i = 0; i < user.Accounts.length; i++) {
            if (this.IsExistForAccount(ruleName, user.Accounts[i])) {
                return true;
            }
        }
        return false;
    }
    IsAllowedForMyUser(name) {
        const dc = this.DataCache;
        let user = dc.LoginUser;
        if (user == null) {
            user = dc.getUserByLogin(dc.FLogin);
        }
        return this.IsAllowedForUser(name, user);
    }
    IsExistForMyUser(name) {
        const dc = this.DataCache;
        let user = dc.LoginUser;
        if (user == null) {
            user = dc.getUserByLogin(dc.FLogin);
        }
        return this.IsExistForUser(name, user);
    }
    // Check rule through all accounts on user
    GetRuleValueForUser(ruleName, user) {
        if (user == null) {
            return null;
        }
        for (let i = 0; i < user.Accounts.length; i++) {
            const ruleValue = this.GetRuleValue(ruleName, user.Accounts[i]);
            if (ruleValue) {
                return ruleValue;
            }
        }
        return null;
    }
    GetRuleValueForMyUser(name) {
        const dc = this.DataCache;
        let user = dc.LoginUser;
        if (user == null) {
            user = dc.getUserByLogin(dc.FLogin);
        }
        return this.GetRuleValueForUser(name, user);
    }
}
